import React from 'react';
import Modal from '@common/modal';
import { useNotificationStore } from '@stores/NotificationStore';
import { useAcceptInterview } from '@repository/match';
import { useMessageActions } from '@stores/MessageStore';
import { hasErrorCode } from '@utils/typeGuard';
import classnames from 'classnames/bind';
import styles from './acceptModal.module.scss';

const cx = classnames.bind(styles);

interface AcceptModalProps {
  visible: boolean;
  optionSn: number | null;
  interviewLocation: string | null;
  date?: string | null;
  handleErrors: (result: string) => void;
  onClose: () => void;
}

const AcceptModal = ({ visible, optionSn, interviewLocation, date, handleErrors, onClose }: AcceptModalProps) => {
  const { fetchMessagesList } = useMessageActions();
  const { mutateAsync: acceptInterview } = useAcceptInterview();
  const positionInfo = useNotificationStore((state) => state.positionInfo);

  if (!positionInfo || !positionInfo.positionSn || !optionSn) return null;

  const { positionSn } = positionInfo;

  const accept = async () => {
    try {
      await acceptInterview({ optionSn, positionSn });
    } catch (e) {
      if (hasErrorCode(e)) handleErrors(e.response.data.errorCode);
    }
    await fetchMessagesList(positionSn);
    onClose();
  };

  return (
    <Modal visible={visible} isUseScrollHidden={false}>
      <div className={cx('inner')}>
        <strong>면접 제안을 수락하시겠어요?</strong>

        {(interviewLocation || date) && (
          <div className={cx('placeArea')}>
            {interviewLocation && (
              <p className={cx('place')}>
                <span className={cx('title')}>장소</span>
                <strong>{interviewLocation}</strong>
              </p>
            )}
            {date && (
              <p className={cx('place')}>
                <span className={cx('title')}>시간</span>
                <strong>{date}</strong>
              </p>
            )}
          </div>
        )}

        <p className={cx('notification')}>
          면접 시간과 장소를 잘 확인하셨나요? 한번 수락하시면
          <br />
          취소가 어려우니 신중하게 선택해 주세요.
        </p>

        <div className={cx('warning')}>*수락한 포지션은 [전형진행중] 단계에서 확인할 수 있습니다.</div>

        <div className={cx('box')}>
          <a className={cx('btn', 'negative')} role={'button'} onClick={onClose}>
            아니오
          </a>
          <a className={cx('btn')} role={'button'} onClick={accept}>
            네, 수락할게요
          </a>
        </div>
      </div>
    </Modal>
  );
};
export default AcceptModal;
